import React, { useEffect, useState } from 'react';
import axios from '../../axiosConfig';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useParams, useNavigate } from 'react-router-dom';
import { useLoading } from '../../components/LoadingContext'; 
import { ToastContainer, toast } from 'react-toastify';
import PaginationTable from '../../components/PaginationTable'; // Importa el componente
import { Card, Row, Col } from 'react-bootstrap'; 
import { Modal, Table } from 'react-bootstrap';
import SelectComponent from '../../components/SelectComponent';
import { cohortesActivas } from '../../components/cohorteUtils';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons

const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado


const InscribirCedula = () => {
    const { cursoId } = useParams();
    const { cedula } = useParams();
    const [cursos, setCursos] = useState([]);


    const [error, setError] = useState(null);
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);  // Estado para la página actual
    const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores
    const [formErrors, setFormErrors] = useState({}); // Estado para almacenar los mensajes de error
    const [patrocinanteSeleccionado, setPatrocinanteSeleccionado] = useState(null);  // Estado para almacenar patrocinante seleccionado
    const handleCloseModal = () => setShowModal(false); // Cierra el modal
    const [showModal, setShowModal] = useState(false);  // Estado para mostrar/ocultar modal
    const [patrocinantes, setPatrocinantes] = useState([]); // Estado para lista de patrocinantes
    const [searchCedula, setSearchCedula] = useState('');    // Estado para controlar búsqueda por cédula
    const [datos, setDatos] = useState(null);
    const [curso, setCurso] = useState(null);
    const [patrocinanteSeleccionado1, setPatrocinanteSeleccionado1] = useState(null);
    const [patrocinanteSeleccionado2, setPatrocinanteSeleccionado2] = useState(null);
    const [patrocinanteSeleccionado3, setPatrocinanteSeleccionado3] = useState(null);
    const [currentPatrocinante, setCurrentPatrocinante] = useState(null); // Para saber cuál botón abrió el modal
    const [paginatedPatrocinantes, setPaginatedPatrocinantes] = useState([]); // Patrocinantes en la página actual
    const [currentPagePatrocinantes, setCurrentPagePatrocinantes] = useState(1);
    const itemsPerPage = 8; // Define el número de elementos por página
    const [totalPages, setTotalPages] = useState(1) 
    const [currentPageCursos, setCurrentPageCursos] = useState(1);
    const [paginatedCursos, setPaginatedCursos] = useState([]); // Usuarios en la página actual
    const [showCursoModal, setShowCursoModal] = useState(false); // Mostrar/ocultar modal de cursos
    const userRole = localStorage.getItem('role');

    const [showConfirmModal, setShowConfirmModal] = useState(false);  
    const [showUserRoleModal, setShowUserRoleModal] = useState(false); 
    const [showUserSearchModal, setShowUserSearchModal] = useState(false);  // Modal de búsqueda de usuarios
    const [paginatedUsers, setPaginatedUsers] = useState([]); // Usuarios en la página actual
    const [currentPageUsers, setCurrentPageUsers] = useState(1);
    const [paginatedRoles, setPaginatedRoles] = useState([]); // Roles en la página actual
    const [currentPageRoles, setCurrentPageRoles] = useState(1);
    const [selectedUserName, setSelectedUserName] = useState(''); // Nombre del usuario seleccionado
    const [showRoleSearchModal, setShowRoleSearchModal] = useState(false);  // Modal de búsqueda de roles
    const [selectedRoleId, setSelectedRoleId] = useState(null);  // ID del rol seleccionado
    const [selectedRoleName, setSelectedRoleName] = useState('');  // Nombre del rol seleccionado
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [comentario, setComentario] = useState('');
     const [cedulaError, setCedulaError] = useState('');  // Estado para el mensaje de error si ya está inscrito
        const [isCedulaValid, setIsCedulaValid] = useState(true); // Estado para manejar si la cédula es válida
        const [showErrorModal, setShowErrorModal] = useState(false); // Modal que explica por qué no se puede inscribir
        const [bloqueoInscripcion, setBloqueoInscripcion] = useState(null); // { reason, message, inscripcion }



const [filterOptions, setFilterOptions] = useState({
    cohorteOptions: [],
    centroOptions: [],
    periodoOptions: [],
    areaOptions: [],
    modalidadOptions: [],
    tipoProgramaOptions: [],
    nivelOptions: [],
    unidadOptions: [],
    grupoOptions:[],
});

const [formData, setFormData] = useState({
    cohorte: '',
    centro_id: '',
    periodo_id: '',
    es_patrocinado: false,
    observaciones:'',
    
    
});


const [filtrosCurso, setFiltrosCurso] = useState({
    area_id: '',
    modalidad_id: '',
    nivel_id: '',
    tipo_programa_id: '',
    unidad_id:'',
    cod:'',
    grupo_id:'',
    curso_descripcion:'',
    activo:true,
    externo:false,
    status:true,
});

const [filtrosPatrocinante, setFiltrosPatrocinante] = useState({
    rif_cedula:'',
    nombre_patrocinante: '',
});


      const handleSelectUser = (user) => {
    setSelectedUserId(user.id); // Guardar ID del usuario seleccionado
    setSelectedUserName(user.username); // Guardar nombre del usuario seleccionado
    setShowUserSearchModal(false); // Cerrar modal de búsqueda
    setShowConfirmModal(true); // Mostrar el modal de confirmación después de seleccionar un usuario
  };


  const handleSelectRole = (role) => {
    setSelectedRoleId(role.id);  // Guardar ID del rol seleccionado
    setSelectedRoleName(role.name);  // Guardar nombre del rol seleccionado
    setShowRoleSearchModal(false);  // Cerrar modal de búsqueda de roles
    setShowConfirmModal(true);  // Mostrar modal de confirmación
  };

  
      const getAllUsers = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/users-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.users;
    
            // Actualizar el estado
            setPaginatedUsers(data); // Datos de la página actual
            setCurrentPageUsers(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Error fetching data');
            setPaginatedUsers([]); // Limpia los datos en caso de error
        }
    };
    
    
    const getAllRoles = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/role-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.roles;
    
            setPaginatedRoles(data); // Datos de la página actual
            setCurrentPageRoles(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
        } catch (error) {
            console.error('Error fetching roles:', error);
            toast.error('Error fetching data');
            setPaginatedRoles([]); // Limpia los datos en caso de error
        }
    };
    
    
    const handleFilterChange = (e) => {
      const { name, value } = e.target;
      setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleUserPageChange = async (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
        await getAllUsers(newPage);
    }
  };
  
  const handleRolePageChange = async (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
        await getAllRoles(newPage);
    }
  };


    useEffect(() => {
        if (cedula) {
            searchDatos(); // Llama a la búsqueda de datos cuando cambie la cédula
        }
    }, [cedula]); // Ejecutar solo cuando cambia la cédula
    
    useEffect(() => {
        setLoading(true);
        handleSeleccionar(); // Solo ejecutar una vez, cuando se monta el componente
    }, []); // Ejecutar una vez, al montar

       useEffect(() => {
            
            if (showUserSearchModal) {
              getAllUsers();
            } else if (showRoleSearchModal) {
              getAllRoles();
            }
          }, [showUserSearchModal, showRoleSearchModal]);
          
          const [filters, setFilters] = useState({
            username:'',
            name:''
          });
    
    
 


    const getAllCursos = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/cursos-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filtrosCurso, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.cursos;
    
            // Actualizar el estado
            setPaginatedCursos(data); // Datos de la página actual
            setCurrentPageCursos(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
            setCursos(data);
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Error fetching data');
            setPaginatedCursos([]); // Limpia los datos en caso de error
            setCursos([]);
        }
    };
    
    const handleFilterCursoChange = (e) => {
        const { name, value } = e.target;
        setFiltrosCurso(prev => ({ ...prev, [name]: value }));
      };
      const handleFilterPatrocinantesChange = (e) => {
        const { name, value } = e.target;
        setFiltrosPatrocinante(prev => ({ ...prev, [name]: value }));
      };
      
      
      const handleCursosPageChange = async (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            await getAllCursos(newPage);
        }
      };

      const handlePatrocinantesPageChange = async (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            await getAllPatrocinantes(newPage);
        }
      };


    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSeleccionarPatrocinante = (patrocinante) => {
        if (currentPatrocinante === 1) {
            setPatrocinanteSeleccionado1(patrocinante);
            setFormData(prevData => ({ ...prevData, patrocinante_id: patrocinante.id }));
        } else if (currentPatrocinante === 2) {
            setPatrocinanteSeleccionado2(patrocinante);
            setFormData(prevData => ({ ...prevData, patrocinante_id2: patrocinante.id }));
        } else if (currentPatrocinante === 3) {
            setPatrocinanteSeleccionado3(patrocinante);
            setFormData(prevData => ({ ...prevData, patrocinante_id3: patrocinante.id }));
        }
        handleCloseModal();
    };
    

    const handleOpenCursoModal = () => {
        getAllCursos(currentPage);  // Obtener los cursos de la página actual
        setShowCursoModal(true);   // Mostrar el modal de cursos
    };
    
    

    const handleSeleccionar = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/select-inc`, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            const { cohorte, centro, periodo, area, tipo_programa, unidad, modalidad, nivel,grupo } = response.data;
    
            // Guardar las opciones en el estado de filterOptions
            setFilterOptions({
                cohorteOptions: cohortesActivas(cohorte),
                centroOptions: centro || [],
                periodoOptions: periodo || [],
                areaOptions: area || [],
                tipoProgramaOptions: tipo_programa || [],
                unidadOptions: unidad || [],
                modalidadOptions: modalidad || [],
                nivelOptions: nivel || [],
                grupoOptions:grupo || [],
            });
    
            setSelectVisible(true);  // Mostrar los selectores
        } catch (error) {
            console.error('Error fetching filter options:', error);
        }
    };
    


    const getAllPatrocinantes = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/patrocinantes-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filtrosPatrocinante, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.patrocinantes;
    
            // Actualizar el estado
            setPaginatedPatrocinantes(data); // Datos de la página actual
            setCurrentPagePatrocinantes(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
            setPatrocinantes(data);
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Error fetching data');
            setPaginatedPatrocinantes([]); // Limpia los datos en caso de error
            setPatrocinantes([]);
        }
    };
    

    
    // Llama a `fetchPatrocinantes` al abrir el modal:
    const handleOpenModal = () => {
        getAllPatrocinantes(currentPage);  // Obtener los patrocinantes de la página actual
        setShowModal(true);               // Mostrar el modal
    };



    const handleSeleccionarCurso = (cursoSeleccionado) => {
        // console.log("Curso seleccionado: ", cursoSeleccionado);  // Verifica si se selecciona correctamente

        setCurso(cursoSeleccionado); // Guardar el curso seleccionado en el estado
        setFormData(prevData => ({
            ...prevData,
            curso_id: cursoSeleccionado.curso_id,  // Almacenar el ID del curso seleccionado
        }));
        setShowCursoModal(false); // Cerrar el modal
    };
    

    
    const searchDatos = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/identificacion/${cedula}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setDatos(response.data); // Almacena los datos encontrados en el estado
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setError('Datos no encontrados'); // Mostrar mensaje si no se encuentran datos
            } else {
                setError('Error al buscar los datos'); // Error de otro tipo
                console.error(error);
            }
        } finally {
            setLoading(false); // Detener el loading cuando termina la búsqueda
        }
    };

  

    const handleComprueba =  async (action) => {
               
                     let errors = {};
            let inscripcionId = null;
    
            // Validar si hay campos vacíos (excepto es_patrocinado)
            if (!cedula) errors.cedula = 'La cédula es requerida';
            if (!formData.cohorte) errors.cohorte = 'El cohorte es requerido';
            if (!formData.centro_id) errors.centro_id = 'El centro es requerido';
            if (!formData.periodo_id) errors.periodo_id = 'El periodo es requerido';
            if (!formData.grupo) errors.grupo = 'El grupo es requerido';
            if (!curso) errors.curso = 'El curso es requerido';
    
    
            // Si hay errores, detener la función y mostrar los errores
            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                return;
            }
    
               const token = localStorage.getItem('token');
          // Verificar si la cédula ya está inscrita en el curso
            const inscripcionResponse = await axios.get(`/cursos_inscripcion/validate`, {
                params: { curso_id: formData.curso_id, cedula_identidad: datos.cedula_identidad, periodo_id:formData.periodo_id,
                    centro_id: formData.centro_id, cohorte: formData.cohorte, grupo: formData.grupo
                 },  // Enviar los parámetros para validar
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
            if (inscripcionResponse.data.alreadyRegistered) {
                // El backend explica el motivo real: 'activa' (tiene una inscripción
                // sin finalizar) o 'duplicado' (mismo periodo/centro/cohorte/grupo).
                // Un EGRESADO ya no se bloquea: puede repetir en otra cohorte.
                const { reason, message, inscripcion } = inscripcionResponse.data;

                setBloqueoInscripcion({ reason, message, inscripcion });
                setCedulaError(message || 'Este participante no puede inscribirse en esta U.C.');
                setIsCedulaValid(false);
                // NO se hace setDatos(null): vaciar el formulario dejaba al usuario
                // sin contexto y sin poder corregir la cohorte o el grupo.
                setShowErrorModal(true);
                setLoading(false);
                return;
            } else {
                setCedulaError('');  // Limpiar error si no está inscrita
                setIsCedulaValid(true);  // Marcar la cédula como válida
                setBloqueoInscripcion(null);
                setShowErrorModal(false);
            }
               
              
                setLoading(true); // Inicia el proceso de carga
                const dataToSend = {
                  ...formData,
                  status:true,
                };
         
                  if (userRole!=='admin') {
                  // Si existen campos vacíos, muestra el modal y detiene el proceso
                  
                  setShowConfirmModal(true);
                  setLoading(false);
                  return;
                }
    
        try {
            const token = localStorage.getItem('token');
    
          
                // Crear un nuevo objeto formDataWithStatus que extiende el formData original
                const formDataWithStatus = {
                    ...formData,
                    status_pay: formData.realiza_aporte === "false" && (!formData.es_patrocinado || formData.es_patrocinado === "false") ? 5 : (formData.es_patrocinado === "true" ? 4 : 1), 
                    status_curso:1,
                    patrocinante_id: formData.es_patrocinado === "true" ? patrocinanteSeleccionado1?.id : null,
                    patrocinante_id2: formData.es_patrocinado === "true" ? patrocinanteSeleccionado2?.id || null :null,
                    patrocinante_id3: formData.es_patrocinado === "true" ? patrocinanteSeleccionado3?.id || null:null,
                    cedula_identidad: cedula,
                    datos_identificacion_id: datos.id, // Usar el ID de la identificación seleccionada
                    curso_id: formData.curso_id,
                    check:true
              
                };
        
                // 1. Realizar la inscripción con todos los datos
                const inscripcionResponse = await axios.post(`/cursos_inscripcion`, formDataWithStatus, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    inscripcionId = inscripcionResponse.data.id; // Asignar el ID recibido
    
    
            // Si la inscripción fue exitosa, redirigir
            toast.success("Participante inscrito con éxito");
            // Redirigir dependiendo de la acción seleccionada y del valor de es_patrocinado
            if (action === 'siguiente') {
                if ((formData.es_patrocinado === "false" || !formData.es_patrocinado)&& formData.realiza_aporte==='true') {
                    // Si no es patrocinado, redirigir a pagos
                    navigate(`/pagos/${cedula}/${inscripcionId}`);
                } else {
                    // Si es patrocinado, redirigir a cursos
                    navigate('/cursos');
                }
            } else {
                // Si la acción es 'guardar', redirigir siempre a cursos
                navigate(`/inscritos/${formData.curso_id}`);
            }
            
        } catch (error) {
            console.error('Error en la inscripción o en la creación de la petición:', error);
            setFormErrors({ general: 'Error en la inscripción o en la creación de la petición' });
            toast.error("Error al inscribir");
        }
    
    
                  setLoading(false); // Detiene el proceso de carga
                
              };
   

               const handleInscripcion = async (action) => {
  try {
    const token = localStorage.getItem('token');


    // Armar payload
    const formDataWithStatus = {
      ...formData,
      status_pay:
        formData.realiza_aporte === "false" &&
        (!formData.es_patrocinado || formData.es_patrocinado === "false")
          ? 5
          : (formData.es_patrocinado === "true" ? 4 : 1),
      status_curso: 1,
      patrocinante_id:  formData.es_patrocinado === "true" ? patrocinanteSeleccionado1?.id ?? null : null,
      patrocinante_id2: formData.es_patrocinado === "true" ? patrocinanteSeleccionado2?.id ?? null : null,
      patrocinante_id3: formData.es_patrocinado === "true" ? patrocinanteSeleccionado3?.id ?? null : null,
      cedula_identidad: cedula,
      datos_identificacion_id: datos.id,
      curso_id: formData.curso_id,
      check: false,
    };

    // 1) Crear la inscripción
    const { data: inscripcionData } = await axios.post(
      `/cursos_inscripcion`,
      formDataWithStatus,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // Asegurar que tenemos el id
    const inscripcionId = inscripcionData?.id;
    if (!inscripcionId) {
      console.error('Respuesta de inscripción:', inscripcionData);
      throw new Error('No se recibió "id" en la respuesta de /cursos_inscripcion');
    }


    // 2) Crear la petición con la clave = inscripcionId
    const requestData = {
      user_id: userId,
      destinatario_id: selectedUserId || null,
      role_id: selectedRoleId || null,
      zona_id: 16,
      status: false,
      finish_time: null,
      key: inscripcionId,
      comentario: comentario,
    };

    await axios.post(`/peticiones`, requestData, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("id de las incs", inscripcionId);
    toast.success("Participante inscrito con éxito");

    // Redirecciones
    if (action === 'siguiente') {
      if ((formData.es_patrocinado === "false" || !formData.es_patrocinado) && formData.realiza_aporte === 'true') {
        navigate(`/pagos/${cedula}/${inscripcionId}`);
      } else {
        navigate('/cursos');
      }
    } else {
      navigate(`/inscritos/${formData.curso_id}`);
    }
  } catch (error) {
    // Log detallado
    if (error.response) {
      console.error('Error:', error.response.status, error.response.data);
    } else {
      console.error('Error:', error.message || error);
    }
    setFormErrors({ general: 'Error en la inscripción o en la creación de la petición' });
    toast.error("Error al inscribir");
  }
};
    
    return (
        <div className="row" style={{ marginTop: '50px' }}>
        <div className="col-lg-6 mx-auto"> {/* Centrado del contenido */}
        <Form.Group controlId="cedula" className="custom-gutter" >
          <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
            <h1>Inscripción a Unidad Curricular {curso && ` ${curso.cod}`}</h1>
            <div>
                
            <Form.Group controlId="cedula" className="custom-gutter">
                <Form.Label>Cédula de Identidad</Form.Label>
                <Form.Control
                    type="text"
                    value={cedula}  // Usamos la cédula del parámetro de la URL
                    readOnly  // Hacemos el campo de solo lectura
                    className="is-valid"  // Marcamos el campo como válido directamente
                />
            </Form.Group>

               
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            {datos && (
                <div className="mt-3">
                <div className="d-flex">
                    <p className="me-3"><strong>Nombres:</strong> {datos.nombres}</p>
                    <p><strong>Apellidos:</strong> {datos.apellidos}</p>
                </div>
               
                

            </div>
            
            )}

            {selectVisible && filterOptions && (
                <div className="mt-3">
                    <Row className="g-2">
                    <Col md={6}>
                    {/* Cohorte Selector */}
                    {formErrors.cohorte && (
                    <div className="text-danger">{formErrors.cohorte}</div>
                )}
                    <SelectComponent
                        options={filterOptions.cohorteOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData.cohorte}
                        handleChange={handleChange}
                        controlId="cohorte"
                        label="Cohorte"
                        required
                    />


                    {/* Centro Selector */}
                    {formErrors.centro_id && (
                    <div className="text-danger">{formErrors.centro_id}</div>
                )}
                    <SelectComponent
                        options={filterOptions.centroOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData.centro_id}
                        handleChange={handleChange}
                        controlId="centro_id"
                        label="Centro"
                        required
                    />
                    </Col>

                    <Col md={6}>
                    {/* Periodo Selector */}
                    {formErrors.periodo_id && (
                    <div className="text-danger">{formErrors.periodo_id}</div>
                )}
                    <SelectComponent
                        options={filterOptions.periodoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData.periodo_id}
                        handleChange={handleChange}
                        controlId="periodo_id"
                        label="Periodo"
                        required

                    />


                    {/* Es grupo */}
                    {formErrors.grupo && (
                        <div className="text-danger">{formErrors.grupo}</div>
                    )}
                   <SelectComponent
                        options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData.grupo}
                        handleChange={handleChange}
                        controlId="grupo"
                        label="Grupo"
                        required

                    />

                        </Col>
                        </Row>
                        <Form.Group controlId="realiza_aporte">
                        <Form.Label>¿Realiza Aporte?</Form.Label>
                        <Form.Control as="select" name="realiza_aporte" value={formData.realiza_aporte} onChange={handleChange}>
                            <option value="">Seleccione</option>
                            <option value={true}>Sí</option>
                            <option value={false}>No</option>
                        </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="es_patrocinado">
                        <Form.Label>¿Es patrocinado?</Form.Label>
                        <Form.Control as="select" name="es_patrocinado" value={formData.es_patrocinado} onChange={handleChange}>
                            <option value="">Seleccione</option>
                            <option value={true}>Sí</option>
                            <option value={false}>No</option>
                        </Form.Control>
                        

                        </Form.Group>
                        {formData.es_patrocinado === "true" && (
                            <>
                                <Form.Group controlId="patrocinante1">
                                    <Form.Label>Patrocinante 1 (Obligatorio)</Form.Label>
                                    <div className="d-flex">
                                        <Form.Control 
                                            type="text" 
                                            value={patrocinanteSeleccionado1 ? patrocinanteSeleccionado1.nombre_patrocinante : 'No seleccionado'} 
                                            readOnly 
                                        />
                                        <Button variant="secondary" onClick={() => { setCurrentPatrocinante(1); handleOpenModal(); }} className="ms-2">
                                            {patrocinanteSeleccionado1 ? 'Cambiar' : 'Seleccionar'}
                                        </Button>
                                        {patrocinanteSeleccionado1 && (
                                            <Button variant="danger" onClick={() => setPatrocinanteSeleccionado1(null)} className="ms-2">
                                                Deseleccionar
                                            </Button>
                                        )}
                                    </div>
                                </Form.Group>
                                
                                <Form.Group controlId="patrocinante2">
                                    <Form.Label>Patrocinante 2 (Opcional)</Form.Label>
                                    <div className="d-flex">
                                        <Form.Control 
                                            type="text" 
                                            value={patrocinanteSeleccionado2 ? patrocinanteSeleccionado2.nombre_patrocinante : 'No seleccionado'} 
                                            readOnly 
                                        />
                                        <Button variant="secondary" onClick={() => { setCurrentPatrocinante(2); handleOpenModal(); }} className="ms-2">
                                            {patrocinanteSeleccionado2 ? 'Cambiar' : 'Seleccionar'}
                                        </Button>
                                        {patrocinanteSeleccionado2 && (
                                            <Button variant="danger" onClick={() => setPatrocinanteSeleccionado2(null)} className="ms-2">
                                                Deseleccionar
                                            </Button>
                                        )}
                                    </div>
                                </Form.Group>

                                <Form.Group controlId="patrocinante3">
                                    <Form.Label>Patrocinante 3 (Opcional)</Form.Label>
                                    <div className="d-flex">
                                        <Form.Control 
                                            type="text" 
                                            value={patrocinanteSeleccionado3 ? patrocinanteSeleccionado3.nombre_patrocinante : 'No seleccionado'} 
                                            readOnly 
                                        />
                                        <Button variant="secondary" onClick={() => { setCurrentPatrocinante(3); handleOpenModal(); }} className="ms-2">
                                            {patrocinanteSeleccionado3 ? 'Cambiar' : 'Seleccionar'}
                                        </Button>
                                        {patrocinanteSeleccionado3 && (
                                            <Button variant="danger" onClick={() => setPatrocinanteSeleccionado3(null)} className="ms-2">
                                                Deseleccionar
                                            </Button>
                                        )}
                                    </div>
                                </Form.Group>
                            </>
                        )}

                  
               <div className="text-danger">{formErrors.curso}</div>
                        <Form.Group controlId="curso">
                            <Form.Label>Unidad Curricular seleccionada</Form.Label>
                            <div className="d-flex">
                                {curso ? (
                                    <>
                                        <Form.Control 
                                            type="text" 
                                            value={curso.curso_descripcion} 
                                            readOnly 
                                        />
                                        <Button variant="secondary" onClick={handleOpenCursoModal} className="ms-2">
                                            Cambiar
                                        </Button>
                                    </>
                                ) : (
                                    <Button variant="info" onClick={handleOpenCursoModal}>
                                        Seleccionar Unidad Curricular
                                    </Button>
                                )}
                            </div>
                            
                        </Form.Group>
                         

                            
                        <Form.Group controlId="observaciones">
                        <Form.Label>Observaciones</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                        />
                        </Form.Group>
                        
                            <div className="d-flex justify-content-around">
                                
                                </div>  
                            </div>
                        )}
                        
                        <div className="d-flex justify-content">
                        <Button variant="info" onClick={() => handleComprueba('guardar')} className='mt-3 'style={{marginRight:"10px"}}>
                            Inscribir y Guardar
                        </Button>
                      {(userRole === 'admin' || userRole === 'coordinador'|| userRole === 'asist-centro' ) && (
                            <Button variant="success" onClick={() => handleComprueba('siguiente')} className='mt-3 'style={{marginRight:"10px"}}>
                                Siguiente
                            </Button>
                         )}


                            
                        </div>
                    
                    </div>
                    </Form.Group>


                    </div>
                    <Modal show={showModal} onHide={handleCloseModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Seleccionar Patrocinante</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div className="d-flex align-items-center">

                        <Form.Control 
                            name="rif_cedula"
                            type="text" 
                            placeholder="Buscar por Rif/Cédula" 
                            value={filtrosPatrocinante.rif_cedula}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Form.Control 
                            name="nombre_patrocinante"
                            type="text" 
                            placeholder="Buscar por Nombre" 
                            value={filtrosPatrocinante.nombre_patrocinante}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Button 
                            variant="info me-2" 
                            onClick={getAllPatrocinantes}
                            style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                        >
                            <FaSearch className="me-1" /> {/* Ícono de lupa */}
                        </Button>
                    </div>

                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Rif/Cédula</th>
                                    <th>Nombre</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {paginatedPatrocinantes.map((patrocinante) => (
                                    <tr key={patrocinante.id}>
                                        <td>{patrocinante.rif_cedula}</td>
                                        <td>{patrocinante.nombre_patrocinante}</td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Button variant="info" onClick={() => handleSeleccionarPatrocinante(patrocinante)} className="me-2">
                                                    <i className="bi bi-check2-square"></i>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-between mt-3">
                            

                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes - 1)}
                                disabled={currentPagePatrocinantes === 1}
                            >
                                Anterior
                            </Button>
                            

                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes + 1)}
                                disabled={currentPagePatrocinantes === totalPages}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>


            <Modal show={showCursoModal} onHide={() => setShowCursoModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar Curso</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row className="mb-3 mt-3">
                <Col>
                <div className="d-flex align-items-center">
                        <Form.Control 
                            name= "cod"
                            type="text" 
                            placeholder="Buscar por Código (COD)" 
                            value={filtrosCurso.cod} 
                            onChange={handleFilterCursoChange} 
                        />
                        <Button 
                            variant="info me-2" 
                            onClick={getAllCursos}
                            style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                        >
                            <FaSearch className="me-1" /> {/* Ícono de lupa */}
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row>
            <Form.Control 
                    name= "curso_descripcion"
                    type="text" 
                    placeholder="Buscar por Nombre" 
                    value={filtrosCurso.curso_descripcion} 
                    onChange={handleFilterCursoChange} 
                />
            </Row>

                    <Row>
                        <Col>
                            <Form.Select 
                            name='area_id'
                            value={filtrosCurso.area_id}
                            onChange={(e) => setFiltrosCurso({ ...filtrosCurso, area_id: e.target.value })}>
                                <option value="">Filtrar por Área</option>
                                {filterOptions.areaOptions.map(area => (
                                    <option key={area.id} value={area.id}>{area.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Select
                            name='unidad_id'
                            value={filtrosCurso.unidad_id}
                             onChange={(e) => setFiltrosCurso({ ...filtrosCurso, unidad_id: e.target.value })}>
                                <option value="">Filtrar por Unidad</option>
                                {filterOptions.unidadOptions.map(unidad => (
                                    <option key={unidad.id} value={unidad.id}>{unidad.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Select
                            name='modalidad_id'
                            value={filtrosCurso.modalidad_id}
                             onChange={(e) => setFiltrosCurso({ ...filtrosCurso, modalidad_id: e.target.value })}>
                                <option value="">Filtrar por Modalidad</option>
                                {filterOptions.modalidadOptions.map(mod => (
                                    <option key={mod.id} value={mod.id}>{mod.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Select 
                            name='nivel_id'
                            value={filtrosCurso.nivel_id}
                            onChange={(e) => setFiltrosCurso({ ...filtrosCurso, nivel_id: e.target.value })}>
                                <option value="">Filtrar por Nivel</option>
                                {filterOptions.nivelOptions.map(nivel => (
                                    <option key={nivel.id} value={nivel.id}>{nivel.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Select 
                            name='grupo_id'
                            value={filtrosCurso.grupo_id}
                            onChange={(e) => setFiltrosCurso({ ...filtrosCurso, grupo_id: e.target.value })}>
                                <option value="">Filtrar por Grupo</option>
                                {filterOptions.grupoOptions.map(grupo => (
                                    <option key={grupo.id} value={grupo.id}>{grupo.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        
                    </Row>

                    <Table striped bordered hover className='mt-3'>
                        <thead>
                            <tr>
                                <th>COD</th>
                                <th>Descripción</th>
                                <th>Horas</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedCursos.map((curso) => (
                                <tr key={curso.id}>
                                    <td>{curso.cod}</td>
                                    <td>{curso.curso_descripcion}</td>
                                    <td>{curso.cantidad_horas}</td>
                                    <td>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Button variant="info" onClick={() => handleSeleccionarCurso(curso)} className="me-2">
                                                <i className="bi bi-check2-square"></i>
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                </Modal.Body>
                <Modal.Footer>
                    
                    <Button
                        variant="secondary"
                        onClick={() => handleCursosPageChange(currentPageCursos - 1)}
                        disabled={currentPageCursos === 1}
                    >
                        Anterior
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => handleCursosPageChange(currentPageCursos + 1)}
                        disabled={currentPageCursos === totalPages}
                    >
                        Siguiente
                    </Button>
                    
                    <Button variant="secondary" onClick={() => setShowCursoModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>


             {/* Modal para seleccionar usuario o rol */}
                    <Modal show={showConfirmModal && !selectedUserId && !selectedRoleId} onHide={() => setShowConfirmModal(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>Enviar Petición</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Seleccione si desea enviar la petición de Confirmación a un Rol o Usuario en especifico
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowUserRoleModal(false)}>
                          Cancelar
                        </Button>
                        <Button variant="warning" onClick={() => {
                          setShowUserRoleModal(false);
                          setShowUserSearchModal(true);
                        }}>
                          Buscar Usuario
                        </Button>
                        <Button variant="info" onClick={() => {
                          setShowUserRoleModal(false);
                          setShowRoleSearchModal(true);
                        }}>
                          Buscar Rol
                        </Button>
                      </Modal.Footer>
                    </Modal>
              
                    {/* Modal de búsqueda de usuarios */}
                    <Modal show={showUserSearchModal} onHide={() => setShowUserSearchModal(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>Buscar Usuario</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          name="username"
                          type="text"
                          placeholder="Buscar por nombre"
                          value={filters.username}
                          onChange={handleFilterChange}
                          className="me-2"
                        />
                        <Button 
                            variant="info me-2" 
                            onClick={getAllUsers}
                            style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                        >
                            <FaSearch className="me-1" /> {/* Ícono de lupa */}
                        </Button>
                        </div>
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Nombre</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedUsers.length > 0 ? (
                                paginatedUsers.map(user => (
                                    <tr key={user.id}>
                                        <td>{user.id}</td>
                                        <td>{user.username}</td>
                                        <td>
                                        <div className="d-flex justify-content-center align-items-center">
              
                                              <Button variant="info" onClick={() => handleSelectUser(user)} className="me-2">
                                                  <i className="bi bi-check2-square"></i>
                                              </Button>
                                          </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">No se encontraron usuarios.</td>
                                </tr>
                            )}
                        </tbody>
              
                        </Table>
                        <div className="d-flex justify-content-between mt-3">
                        <Button
                          variant="secondary"
                            onClick={() => handleUserPageChange(currentPageUsers - 1)}
                            disabled={currentPageUsers === 1}
                        >
                            Anterior
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={() => handleUserPageChange(currentPageUsers + 1)}
                            disabled={currentPageUsers === totalPages}
                        >
                            Siguiente
                        </Button>
              
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowUserSearchModal(false)}>
                          Cerrar
                        </Button>
                        <Button variant="light" onClick={() => {
                          setShowUserSearchModal(false);
                          setShowUserRoleModal(true);
                        }}>
                          Volver
                        </Button>
                      </Modal.Footer>
                    </Modal>
              
                    {/* Modal de búsqueda de roles */}
                    <Modal show={showRoleSearchModal} onHide={() => setShowRoleSearchModal(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>Buscar Rol</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          name="name"
                          type="text"
                          placeholder="Buscar por nombre"
                          value={filters.name}
                          onChange={handleFilterChange}
                          className="me-2" // Margen derecho para separar del botón
                          style={{ flex: 1 }} // Ajusta el ancho para que ocupe el espacio disponible
                        />
                        <Button
                          variant="info"
                          onClick={getAllRoles}
                          style={{ whiteSpace: 'nowrap' }} // Evita que el texto del botón se rompa en varias líneas
                        >
                          <FaSearch className="me-1" /> Buscar {/* Ícono de lupa */}
                        </Button>
                      </div>
              
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Nombre</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                          {paginatedRoles.length > 0 ? (
                              paginatedRoles.map(role => (
                                  <tr key={role.id}>
                                      <td>{role.id}</td>
                                      <td>{role.name}</td>
                                      <td>
              
                                          <div className="d-flex justify-content-center align-items-center">
              
                                            <Button variant="info" onClick={() => handleSelectRole(role)} className="me-2">
                                                <i className="bi bi-check2-square"></i>
                                            </Button>
                                          </div>
                                      </td>
                                  </tr>
                              ))
                          ) : (
                              <tr>
                                  <td colSpan="3">No se encontraron roles.</td>
                              </tr>
                          )}
                      </tbody>
              
                        </Table>
                        <div className="d-flex justify-content-between mt-3">
                        <Button
                          variant="secondary"
                          onClick={() => handleRolePageChange(currentPageRoles - 1)}
                          disabled={currentPageRoles === 1}
                      >
                          Anterior
                      </Button>
                        {userRole === 'admin'  || userRole === 'coordinador' 
                          || userRole === 'promotor' || userRole === 'facilitador' || userRole === 'servicio-com'  
                          || userRole === 'asist-centro'? (
                            <Button
                                variant="secondary"
                                onClick={() => handleRolePageChange(currentPageRoles + 1)}
                                disabled={currentPageRoles === totalPages}
                            >
                                Siguiente
                            </Button>
                          ) : null}
              
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowRoleSearchModal(false)}>
                          Cerrar
                        </Button>
                        <Button variant="light" onClick={() => {
                          setShowRoleSearchModal(false);
                          setShowUserRoleModal(true);
                        }}>
                          Volver
                        </Button>
                      </Modal.Footer>
                    </Modal>
              
              
                    {/* Modal de confirmación para enviar la solicitud al usuario */}
                    <Modal show={selectedUserId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {selectedUserId
                          ? `¿Seguro que deseas enviar la solicitud al usuario ${selectedUserName}?`
                          : 'No se ha seleccionado ningún usuario.'}
                      </Modal.Body>
                      <Form.Group controlId="comentario" style={{ margin: '10px 20px' }}>
                        <Form.Label>Comentario (opcional)</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                          value={comentario}
                          onChange={(e) => setComentario(e.target.value)}
                          style={{ padding: '5px', resize: 'none' }}
                        />
                      </Form.Group>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                        <Button variant="success" onClick={handleInscripcion} disabled={!selectedUserId}>Confirmar</Button>
                        <Button variant="light" onClick={() => {
                          setShowConfirmModal(false);
                          setShowUserSearchModal(true);
                        }}>
                          Volver
                        </Button>
                      </Modal.Footer>
                    </Modal>
              
                    {/* Modal de confirmación para enviar la solicitud al rol */}
                    <Modal show={selectedRoleId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {selectedRoleId
                          ? <p>¿Seguro que deseas enviar la solicitud al rol {selectedRoleName}?</p>
                          : <p>No se ha seleccionado ningún rol.</p>}
                        <Form.Group controlId="comentario" style={{ margin: '10px 0' }}>
                          <Form.Label>Comentario (opcional)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                            value={comentario}
                            onChange={(e) => setComentario(e.target.value)}
                            style={{ padding: '5px', resize: 'none' }}
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                        <Button variant="success" onClick={handleInscripcion} disabled={!selectedRoleId}>Confirmar</Button>
                        <Button variant="light" onClick={() => {
                          setShowConfirmModal(false);
                          setShowRoleSearchModal(true);
                        }}>Volver</Button>
                      </Modal.Footer>
                    </Modal>

                    {/* Antes este aviso no existía: la validación fallaba en silencio,
                        el usuario pulsaba Inscribir y no ocurría nada visible. */}
                    <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {bloqueoInscripcion?.reason === 'activa'
                            ? 'Inscripción en curso sin finalizar'
                            : 'Inscripción duplicada'}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p>{cedulaError}</p>

                        {bloqueoInscripcion?.inscripcion && (
                          <Table size="sm" bordered className="mb-0">
                            <tbody>
                              <tr>
                                <th style={{ width: '35%' }}>Estatus</th>
                                <td>{bloqueoInscripcion.inscripcion.estado_label}</td>
                              </tr>
                              <tr>
                                <th>Cohorte</th>
                                <td>{bloqueoInscripcion.inscripcion.cohorte || '—'}</td>
                              </tr>
                              <tr>
                                <th>Centro</th>
                                <td>{bloqueoInscripcion.inscripcion.centro || '—'}</td>
                              </tr>
                              <tr>
                                <th>Periodo</th>
                                <td>{bloqueoInscripcion.inscripcion.periodo || '—'}</td>
                              </tr>
                              <tr>
                                <th>Grupo</th>
                                <td>{bloqueoInscripcion.inscripcion.grupo || '—'}</td>
                              </tr>
                            </tbody>
                          </Table>
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
                          Entendido
                        </Button>
                      </Modal.Footer>
                    </Modal>

</div>

    );
};

export default InscribirCedula;